/* eslint-disable react/react-in-jsx-scope */
import { useAuth } from "@/auth/hooks/useAuth";
import useImageCompressor from "@/hooks/useImageCompressor";
import usePostData from "@/hooks/usePostData";
import usePostMultipart from "@/hooks/usePostMultipart";
import { useLogoStore } from "@/store/store";
import { Camera } from "lucide-react";
import { useState } from "react";
import { FileInput, FileUploader } from "../extension/file-upload";
import { toast } from "../ui/use-toast";

const ManageLogo = () => {
  const { handleCompressImage } = useImageCompressor();
  const { postMultipart } = usePostMultipart();
  const [uploadLogoLoading, setUploadLogoLoading] = useState(false);
  const [picture, setPicture] = useState(null);
  const { logoUrl, setLogoUrl } = useLogoStore();
  const [loadingSaveFinancer, setLoadingSaveFinancer] = useState(false);
  const { postData } = usePostData<any>();
  const { user } = useAuth();
  const handlePictureChange = async (value) => {
    if (value) {
      setUploadLogoLoading(true);
      const data = new FormData();

      data.append("type", 10);

      // Compresser l'image avant l'upload
      const compressedBlob = await handleCompressImage(value[0], 500, 300, 0.9);
      if (compressedBlob) {
        for (let i = 0; i < value.length; i++) {
          data.append("files[]", compressedBlob);
        }
      } else {
        for (let i = 0; i < value.length; i++) {
          data.append("files[]", value[i]);
        }
      }

      const newMedias = await postMultipart({
        url: `${import.meta.env.VITE_IP_API}/api/media/temp/upload`,
        data,
      });
      if (
        !Array.isArray(newMedias) &&
        newMedias.success !== undefined &&
        newMedias.success !== null &&
        !newMedias.success
      ) {
        toast({
          title: newMedias.message,
          duration: 1000,
        });
        setUploadLogoLoading(false);
        return;
      }

      setLogoUrl(newMedias[0].uri);

      await handleSubmit(newMedias[0]);
      setUploadLogoLoading(false);
      return;
    }
  };

  async function handleSubmit(media) {
    setLoadingSaveFinancer(true);

    const res = await postData({
      url: `${import.meta.env.VITE_IP_API}/api/financer/${user?.id}`,
      data: {
        logo: media.id,
      },
    });
    if (res === null) {
      setLoadingSaveFinancer(false);
      return;
    }

    toast({
      title: "Votre profil a bien été modifié.",
      duration: 1000,
    });
    setLoadingSaveFinancer(false);
  }
  if (loadingSaveFinancer) return <div>Chargement...</div>;
  return (
    <div className="">
      <FileUploader
        value={[]}
        onValueChange={handlePictureChange}
        dropzoneOptions={{
          multiple: false,
        }}
        className={`relative size-full `}
      >
        <FileInput className="size-full rounded-[20px] border border-dashed border-background/50 relative">
          {uploadLogoLoading ? (
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="animate-spin"
              >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
              </svg>
            </div>
          ) : (
            <div className="bg-none size-8 p-0 rounded-full flex justify-center items-center">
              <Camera size={18} />
            </div>
          )}
        </FileInput>
      </FileUploader>
    </div>
  );
};

export default ManageLogo;
